import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	FIND_COMPANY_HOTEL_PARITY_EXPORT_REPORT_EXECUTION_QUERY,
	FIND_COMPANY_HOTEL_PARITY_EXPORT_REPORT_EXECUTIONS_QUERY,
	SAVE_PARITY_EXPORT_REPORT_MUTATION,
} from '@app/model/parity/_export/service/ParityExportGraphQLQueries';
import ParityExportReportInput from '@app/model/parity/_export/input/ParityExportReportInput';
import ParityExportReportExecution from '@app/model/parity/_export/ParityExportReportExecution';
import ExportService from '@app/model/market_state/_export/service/ExportService';

class ParityExportService {
	public static saveParityExportReport = (input: ParityExportReportInput): Promise<ParityExportReportExecution> => {
		return GraphQLExecutor.execute<ParityExportReportExecution>(SAVE_PARITY_EXPORT_REPORT_MUTATION, { input });
	};

	public static findCompanyHotelParityExportReportExecution = (
		companyHotelId: number,
		reportExecutionId: number,
	): Promise<ParityExportReportExecution> => {
		return GraphQLExecutor.execute<ParityExportReportExecution>(
			FIND_COMPANY_HOTEL_PARITY_EXPORT_REPORT_EXECUTION_QUERY,
			{ companyHotelId, reportExecutionId },
		);
	};

	public static findCompanyHotelParityExportReportExecutions = (
		companyHotelId: number,
	): Promise<ParityExportReportExecution[]> => {
		return GraphQLExecutor.execute<ParityExportReportExecution[]>(
			FIND_COMPANY_HOTEL_PARITY_EXPORT_REPORT_EXECUTIONS_QUERY,
			{ companyHotelId },
		);
	};

	public static download = (exp: ParityExportReportExecution): Promise<void> => {
		return ExportService.downloadFile(exp, exp.execution.filename ?? `${exp.report.name}.xlsx`);
	};
}

export default ParityExportService;
